import { Redirect, useLocalSearchParams } from 'expo-router'

import { Header } from '@/src/elements/header'
import { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { IntentionPrayersScreen } from '@/src/features/intention/ui/screens/IntentionPrayersScreen/IntentionPrayersScreen'
import { isIntentionTypeValid } from '@/src/features/intention/utils/isIntentionTypeValid'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

const IntentionPrayersRouterPage = () => {
  const params = useLocalSearchParams<{ type: INTENTION_TYPE; id: string }>()
  const { routes } = useRoutes()
  const { t } = useTranslate()

  const intentionId = params.id
  const type = params.type || INTENTION_TYPE.INTENTION

  const { handleBackPress } = useBackHandlePress(routes.intentions())
  if (!intentionId || !isIntentionTypeValid(type)) return <Redirect href={routes.intentions()} />

  return (
    <>
      <Header
        leftButtons={[{ startIcon: ICON.ARROW_LEFT, onPress: handleBackPress, type: 'icon' }]}
        title={t('intention.prayers.list.title')}
        className="bg-primary-bg-light"
      />
      <IntentionPrayersScreen intentionId={parseInt(intentionId, 10)} type={type || INTENTION_TYPE.INTENTION} />
    </>
  )
}

export default IntentionPrayersRouterPage
